import { Navigate, Outlet } from "@tanstack/react-router";
import { useAuth } from "./useAuth";
import { AUTH_ROUTES } from "./constants";

export function ProtectedRoute() {
  const { isAuthenticated, status } = useAuth();

  if (status === "loading") {
    return (
      <div
        className="flex min-h-screen items-center justify-center"
        role="status"
        aria-label="Loading"
      >
        <div className="border-muted border-t-primary h-8 w-8 animate-spin rounded-full border-4" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={AUTH_ROUTES.LOGIN} />;
  }

  return <Outlet />;
}
